export enum actionTypes {
  REQUEST_UNLOCK_LINKS = "request_unlock_links",
  RECEIVE_UNLOCK_LINKS = "receive_unlock_links",
  
  UPDATE_LINK_LOCK = "update_link_lock",
  COMPLETE_UNLOCK_LINKS = "complete_unlock_links", 
}
